import React from 'react'
import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

function Popup({show,handleClose,handleDelete}) {
  return (
    <>
    <Modal show={show} size="sm" centered>
        <Modal.Body>Are you sure about this?!</Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose} size= 'sm'>
            No
          </Button>
          <Button variant="info" onClick={handleDelete} size= 'sm'>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Popup